export * from '@primeuix/themes/lara/galleria';
export { default } from '@primeuix/themes/lara/galleria';
